import Select, { MultiValue, SingleValue, components } from 'react-select';
import './SelectionBox.scss';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowdown.svg';
import { IOption } from 'types/common';

interface IProps {
  label?: string;
  name: string;
  value: IOption;
  options: IOption[];
  onChange: (value: SingleValue<IOption>, name: string) => void;
}

const SelectionBox = ({ label = '', name, value, options, onChange }: IProps) => {
  const colourStyles = {
    control: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
      ...styles,
      backgroundColor: 'none',
      border: 'none',
      width: '100px',
    }),
  };

  return (
    <div className="selectionBoxComponent">
      <div className="textLabel">{label}</div>

      <Select
        className="selectionBoxComponent__select"
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: () => (
            <div style={{ paddingRight: '15px' }}>
              <ArrowDownIcon />
            </div>
          ),
        }}
        placeholder="시급"
        styles={colourStyles}
        value={value}
        options={options}
        onChange={(newValue) => onChange(newValue, name)}
      />
    </div>
  );
};

export default SelectionBox;
